import React from "react";
import { Row, Col, Card, CardBody, Badge, Nav, NavItem, NavLink } from "reactstrap";
import CommonDataTable from "../../../common/DataTable";
import { StatCard } from "../../../Components/Common/StatCard";
import {
    getROAdminInsightsConfig,
    getROBidHistoryColumns,
    getROFinancialOverviewConfig,
    getROQuickStatsConfig,
    getROSummaryCardsConfig,
    InfoRow
} from "../../../Components/Common/columns/BidTranjections";
import BalanceHistoryTab from "./BalanceHistoryTab";
import GameHistoryTab from "./GameHistoryTab";





const AmericanRoulette = ({
    historyData = {},
    historyLoading,
    filters,
    activeTab,
    setActiveTab,
    userId,
    onFetchData,
    handlePageChange,
    handleRowsPerPageChange
}) => {
    const { tabsConfig } = require("../../../Components/Common/columns/BidTranjections");
    const classnames = require('classnames');

    // Extract data from historyData
    const pagination = historyData.pagination || {};
    const recentBids = historyData.detailedHistory?.recentBids || [];
    const userInfo = historyData.userInfo || {};
    const currentAccountStatus = historyData.currentAccountStatus || {};
    const financialSummary = historyData.financialSummary || {};
    const numberAnalysis = historyData.numberAnalysis || [];
    const resultStatistics = historyData.resultStatistics || {};
    const adminInsights = historyData.adminInsights || {};
    const quickStats = historyData.quickStats || {};


    // Get configurations
    const mergedFinancialData = {
        ...financialSummary,
        acBalance: currentAccountStatus.accountBalance || 0,
        pendingToClaim: currentAccountStatus.pendingWinningBalance || 0
    };

    const summaryCards = getROSummaryCardsConfig(mergedFinancialData);
    const financialOverviewData = getROFinancialOverviewConfig(mergedFinancialData);

    const quickStatsData = getROQuickStatsConfig(quickStats);

    const adminInsightsData = getROAdminInsightsConfig(adminInsights);
    const bidsColumns = getROBidHistoryColumns();

    return (
        <>
            {/* Summary Cards */}
            <div className="p-3 bg-white border-bottom">
                <Row className="mb-4">
                    {summaryCards.map((card, idx) => (
                        <Col xl={3} md={6} key={idx} className="mb-3">
                            <StatCard {...card} />
                        </Col>
                    ))}
                </Row>


            </div>

            {/* Financial Overview */}
            <div className="p-3 bg-white border-bottom">
                <h6 className="mb-3 fw-semibold">
                    <i className="ri-money-dollar-circle-line me-2 text-primary"></i>
                    Financial Overview - American Roulette
                </h6>
                <Row>
                    {financialOverviewData.map((colData, idx) => (
                        <Col md={4} key={idx}>
                            <Card className="border-0 shadow-sm">
                                <CardBody>
                                    {colData.map((item, itemIdx, array) => (
                                        <InfoRow
                                            key={itemIdx}
                                            {...item}
                                            noBorder={itemIdx === array.length - 1}
                                        />
                                    ))}
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>

            {/* Tabs Navigation */}
            <Nav tabs className="px-3 pt-3 bg-white">
                {tabsConfig.map(tab => (
                    <NavItem key={tab.id}>
                        <NavLink
                            className={classnames({ active: activeTab === tab.id })}
                            onClick={() => setActiveTab(tab.id)}
                            style={{
                                cursor: 'pointer',
                                borderRadius: '8px 8px 0 0',
                                fontWeight: activeTab === tab.id ? '600' : '400'
                            }}
                        >
                            <i className={`${tab.icon} me-2`}></i>
                            {tab.label}
                        </NavLink>
                    </NavItem>
                ))}
            </Nav>

            {/* Tab Content */}
            <div className="p-3 bg-white">
                {activeTab === '1' && (
                    <div>
                        {recentBids.length === 0 ? (
                            <div className="text-center py-5">
                                <i className="ri-inbox-line" style={{ fontSize: "48px", color: "#dee2e6" }} />
                                <p className="text-muted mt-3">No bids found for this user in American Roulette</p>
                            </div>
                        ) : (
                            <div style={{ overflowX: 'hidden' }}>
                                <CommonDataTable
                                    columns={bidsColumns}
                                    data={recentBids}
                                    loading={historyLoading}
                                    totalRows={pagination.totalBids || 0}
                                    filterParams={filters}
                                    fetchData={(newParams) => {
                                        if (userId && onFetchData) onFetchData(newParams);
                                    }}
                                    cardcusclass="mt-0 mb-0"
                                    callcusclass="p-0 mt-0"
                                    searchEnable={false}
                                    showAddButton={false}
                                    showExportButton={false}
                                    checkboxEnabled={false}
                                    paginationPerPage={filters.limit || 10}
                                    paginationDefaultPage={filters.page || 1}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handleRowsPerPageChange}
                                    striped
                                    highlightOnHover
                                    noHeader
                                />
                            </div>
                        )}
                    </div>
                )}

                {activeTab === '2' && (
                    <BalanceHistoryTab userId={userId} gameType={filters?.gameType || 'ro'} />
                )}

                {activeTab === '4' && <GameHistoryTab userId={userId} />}

                {activeTab === '3' && (
                    <Row>
                        {/* Result Statistics Summary */}
                        <Col lg={12} className="mb-4">
                            <div className="d-flex gap-3 overflow-auto pb-2">
                                {Object.entries(resultStatistics).map(([key, stats]) => (
                                    <Card key={key} className="flex-fill border-0 shadow-sm mb-0 ripple-effect" style={{ minWidth: '200px' }}>
                                        <CardBody className="p-3">
                                            <div className="d-flex align-items-center mb-2">
                                                <Badge
                                                    color={key === 'win' ? 'success' : key === 'lose' ? 'danger' : 'warning'}
                                                    className="rounded-circle p-2 me-2"
                                                >
                                                    <i className={`ri-${key === 'win' ? 'checkbox-circle' : key === 'lose' ? 'close-circle' : 'time'}-line`} />
                                                </Badge>
                                                <span className="text-uppercase fw-bold text-muted" style={{ fontSize: '10px' }}>{key} Stats</span>
                                            </div>
                                            <h4 className="mb-1 fw-bold">{stats.count || 0} <small className="text-muted fw-normal" style={{ fontSize: '12px' }}>Rounds</small></h4>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="text-muted small">Total Spent: <span className="text-dark fw-semibold">{stats.totalAmount || 0}</span></span>
                                                {key === 'win' && (
                                                    <span className="text-success small fw-bold">Won: {stats.totalReward || 0}</span>
                                                )}
                                            </div>
                                        </CardBody>
                                    </Card>
                                ))}
                            </div>
                        </Col>

                        <Col md={8}>
                            <Card className="mb-3 border-0 shadow-sm h-100">
                                <CardBody>
                                    <div className="d-flex justify-content-between align-items-center mb-4">
                                        <h6 className="mb-0 fw-bold">
                                            <i className="ri-bar-chart-2-line me-2 text-primary"></i>
                                            Bet Analysis by Placement
                                        </h6>
                                        <Badge color="light" className="text-dark border px-2 py-1">Sorted by Volume</Badge>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-hover align-middle mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th className="fw-bold fs-12">Placement</th>
                                                    <th className="fw-bold fs-12 text-center">Total Bets</th>
                                                    <th className="fw-bold fs-12 text-center">Volume</th>
                                                    <th className="fw-bold fs-12 text-center">Avg Win Rate</th>
                                                    <th className="fw-bold fs-12 text-end" style={{ width: '100px' }}>Performance</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {numberAnalysis.map((data, index) => {
                                                    const rawNum = data.number || '';
                                                    const isRed = ["RED", "1", "3", "5", "7", "9", "12", "14", "16", "18", "19", "21", "23", "25", "27", "30", "32", "34", "36"].includes(rawNum);
                                                    const isBlack = ["BLACK", "2", "4", "6", "8", "10", "11", "13", "15", "17", "20", "22", "24", "26", "28", "29", "31", "33", "35"].includes(rawNum);
                                                    const isGreen = ["0", "00"].includes(rawNum);

                                                    const winRate = parseFloat(data.winRate || 0);

                                                    // Helper to get shortened icon text
                                                    const getIconText = (text) => {
                                                        if (text === '1_12') return '1st';
                                                        if (text === '13_24') return '2nd';
                                                        if (text === '25_36') return '3rd';
                                                        if (text.startsWith('COL_')) return `C${text.split('_')[1]}`;
                                                        if (text === 'RED') return 'R';
                                                        if (text === 'BLACK') return 'B';
                                                        if (text === 'EVEN') return 'EV';
                                                        if (text === 'ODD') return 'OD';
                                                        if (text === '1_18') return '1-18';
                                                        if (text === '19_36') return '19-36';
                                                        return text;
                                                    };

                                                    const iconText = getIconText(rawNum);
                                                    const fontSize = iconText.length > 3 ? '7px' : iconText.length > 2 ? '8px' : '10px';

                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <div
                                                                        className="rounded-circle d-flex align-items-center justify-content-center text-white fw-bold me-2"
                                                                        style={{
                                                                            width: '28px',
                                                                            height: '28px',
                                                                            fontSize: fontSize,
                                                                            backgroundColor: isRed ? '#ef4444' : isBlack ? '#111827' : isGreen ? '#10b981' : '#6b7280'
                                                                        }}
                                                                    >
                                                                        {iconText}
                                                                    </div>
                                                                    <span className="fw-semibold text-dark fs-13">
                                                                        {rawNum.replace('_', '-').replace('COL_', 'Column ')}
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            <td className="text-center fw-medium">{data.totalBets || 0}</td>
                                                            <td className="text-center font-monospace">{data.totalAmount || 0}</td>
                                                            <td className="text-center">
                                                                <Badge color={winRate > 20 ? 'success' : winRate > 0 ? 'warning' : 'light'} className={`px-2 ${winRate > 0 ? '' : 'text-dark'}`}>
                                                                    {winRate.toFixed(1)}%
                                                                </Badge>
                                                            </td>

                                                            <td className="text-end">
                                                                <div className="progress progress-sm rounded-pill" style={{ height: '4px' }}>
                                                                    <div
                                                                        className={`progress-bar bg-${winRate > 20 ? 'success' : winRate > 0 ? 'warning' : 'secondary'}`}
                                                                        role="progressbar"
                                                                        style={{ width: `${Math.min(winRate, 100)}%` }}
                                                                    />
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col md={4}>
                            <Card className="mb-3 border-0 shadow-sm">
                                <CardBody>
                                    <h6 className="mb-4 fw-bold">
                                        <i className="ri-flashlight-line me-2 text-primary"></i>
                                        Performance Overview
                                    </h6>
                                    {quickStatsData.map((stat, index, array) => (
                                        <InfoRow
                                            key={index}
                                            {...stat}
                                            noBorder={index === array.length - 1}
                                        />
                                    ))}
                                </CardBody>
                            </Card>

                            <Card className="mb-3 border-0 shadow-sm">
                                <CardBody>
                                    <h6 className="mb-4 fw-bold">
                                        <i className="ri-admin-line me-2 text-primary"></i>
                                        Profitability Matrix
                                    </h6>
                                    {adminInsightsData.map((insight, index, array) => (
                                        <InfoRow
                                            key={index}
                                            {...insight}
                                            noBorder={index === array.length - 1}
                                        />
                                    ))}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                )}

            </div>
        </>
    );
};

export default AmericanRoulette;
